module.exports = "../assets/media_follow_soon.86a75738.jpg";